export default __webpack_public_path__ + "static/media/equity-banner-mob.4f4cf16f.jpg";